import React, { useState } from 'react';
import { MenuIcon, XIcon, ArrowUpRightIcon } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-sm border-b border-gray-100 shadow-sm" data-id="element-126">
      <div className="container mx-auto px-4 py-5 flex justify-between items-center" data-id="element-127">
        <div className="flex items-center" data-id="element-128">
          <span className="text-2xl tracking-tight flex items-center" data-id="element-129">
            <span className="font-bold text-gray-900" data-id="element-130">swedenmark</span>
            <span className="mx-0.5 text-[1.6rem] leading-none translate-y-[-1px] text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-red-500" data-id="element-131">
              &bull;
            </span>
            <span className="font-semibold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-red-500" data-id="element-132">
              studio
            </span>
          </span>
        </div>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-133">
          <a href="#about" className="text-gray-600 hover:text-blue-600 transition-colors" data-id="element-134">
            About
          </a>
          <a href="#services" className="text-gray-600 hover:text-blue-600 transition-colors" data-id="element-135">
            Services
          </a>
          <a href="#contact" className="text-gray-600 hover:text-blue-600 transition-colors" data-id="element-136">
            Contact
          </a>
          <a href="https://www.swedenmark.ai" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-sm text-gray-500 hover:text-blue-600 transition-colors border-l border-gray-200 pl-8" data-id="element-137">
            Swedenmark AI
            <ArrowUpRightIcon size={14} data-id="element-138" />
          </a>
        </nav>
        {/* Mobile Menu Button */}
        <button className="md:hidden text-gray-600" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-139">
          {isMenuOpen ? <XIcon size={24} data-id="element-140" /> : <MenuIcon size={24} data-id="element-141" />}
        </button>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-white border-t border-gray-100 py-4" data-id="element-142">
          <div className="container mx-auto px-4 flex flex-col space-y-4" data-id="element-143">
            <a href="#about" className="text-gray-600 hover:text-blue-600 transition-colors py-2" onClick={() => setIsMenuOpen(false)} data-id="element-144">
              About
            </a>
            <a href="#services" className="text-gray-600 hover:text-blue-600 transition-colors py-2" onClick={() => setIsMenuOpen(false)} data-id="element-145">
              Services
            </a>
            <a href="#contact" className="text-gray-600 hover:text-blue-600 transition-colors py-2" onClick={() => setIsMenuOpen(false)} data-id="element-146">
              Contact
            </a>
            <a href="https://www.swedenmark.ai" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-gray-500 hover:text-blue-600 transition-colors py-2 border-t border-gray-100 pt-4" onClick={() => setIsMenuOpen(false)} data-id="element-147">
              Swedenmark AI
              <ArrowUpRightIcon size={14} data-id="element-148" />
            </a>
          </div>
        </div>}
    </header>;
}